import { useMemo, useState } from 'react';

import {
  PickupPoint,
  PointType,
  PickupPointTypeOption
} from '@/util/map-point-maps/types';
import { getPointsByTypes } from '@/util/map-point-maps/utils/getPointsByTypes';
import {
  getPointTypes,
  getPickupPointTypeOptions
} from '@/util/map-point-maps/utils/getPointTypes';

export interface UsePointsControllerOptions {
  pointTypesOptions?: PickupPointTypeOption[];
}

/**
 * Хук для управления точками самовывоза
 */
export function usePointsController(
  points: PickupPoint[],
  options?: UsePointsControllerOptions
) {
  const pointTypes = useMemo(() => getPointTypes(points), [points]);
  const pointTypesOptions = options?.pointTypesOptions ?? getPickupPointTypeOptions();

  const pointsByTypes = useMemo(
    () => getPointsByTypes(points, pointTypes),
    [points, pointTypes]
  );

  const [selectedPointType, setSelectedPointType] = useState<PointType | null>(null);

  /**
   * Видимые точки самовывоза после фильтрации
   */
  const visiblePoints = useMemo(() => {
    return selectedPointType === null
      ? pointsByTypes
      : pointsByTypes.filter((points) => points.type === selectedPointType);
  }, [pointsByTypes, selectedPointType]);

  /**
   * Обработчик изменения типа точки самовывоза
   */
  const handlePointTypeChange = (type: PointType | null) => {
    setSelectedPointType(type);
  };

  return {
    pointTypes,
    pointsByTypes,
    visiblePoints,
    selectedPointType,
    pointTypesOptions,
    setSelectedPointType,
    handlePointTypeChange
  };
}
